import { Component } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'chromebook-selector';
  environmentName: string = '';
  currentRoute: string = '/'

  constructor(
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private router: Router
  ){
    this.matIconRegistry.addSvgIcon(
      'icon_kiosk', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-use-case-kiosk.svg')
    );
    this.router.events.subscribe((url:any) => {
      this.currentRoute = url.url === undefined ? this.currentRoute : url.url
    });
  }
}
